import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set document title
document.title = 'KM Consulting & Tech | Web Design Agency London UK Nigeria | Digital Marketing Company';
render(<App data-id="element-307" />, document.getElementById('root'));